import { Outlet } from "react-router-dom"

const Stocklayout = () => {
    return(
        <div>
            <Outlet />
        </div>
    );
}

export default Stocklayout;